import type { Drill } from '@acepoker/contract'
import { DrillKind, GameFlavor, StopAt } from '@acepoker/contract'

export const gameFormatList: { id: string; label: string; value: Drill['gaming_configuration'] }[] =
  [
    {
      id: 'nlhe-8-3+a',
      label: 'NLHE, 8-max, 3 blinds + Ante',
      value: {
        game: 'NLHE',
        blinds: [50, 100, 200],
        antes: 50
      }
    }
    // {
    //   id: 'nlhe-8-2',
    //   label: 'NLHE, 8-max, 2 blinds',
    //   value: {
    //     game: 'NLHE',
    //     blinds: [50, 100],
    //     antes: 0
    //   }
    // },
    // {
    //   id: 'nlhe-8-2+a',
    //   label: 'NLHE, 8-max, 2 blinds + Ante',
    //   value: {
    //     game: 'NLHE',
    //     blinds: [50, 100],
    //     antes: 50
    //   }
    // },
    // {
    //   id: 'nlhe-8-3',
    //   label: 'NLHE, 8-max, 3 blinds',
    //   value: {
    //     game: 'NLHE',
    //     blinds: [50, 100, 200],
    //     antes: 0
    //   }
    // },
  ] as const

export const stopAtList = [StopAt.Hand, StopAt.Street, StopAt.Move] as const
export const botsTypeList = ['GTO', 'Fish', 'LAG', 'TAG'] as const
export const sessionList = [0, 20, 50, 100] as const

export const drillKindValues = [DrillKind.Street, DrillKind.Sequence]

// drill preflop config
export const positionGroup = ['Blinds', 'EP', 'LP']
export const positionAuthority = ['IP', 'OOP']
export const raiseCount = ['0', '1', '2+']
export const opponentsCount = ['1', '2+']

// drill defaults
export const DRILL_DEFAULTS_SEQUENCE = {
  sequence: []
}
export const DRILL_DEFAULTS_PREFLOP = {
  positionGroup: 'Blinds',
  positionAuthority: 'OOP',
  raiseCount: '0',
  opponentsCount: '1'
}
export const DRILL_DEFAULTS_POSTFLOP = {
  positionAuthority: 'OOP',
  preflopRaiseCount: '0',
  postflopRaiseCount: '0',
  opponentsCount: '1'
}
export const DRILL_DEFAULTS_BOMB_POT = {
  positionGroup: 'any',
  anteMultiplier: 5
}
export const DRILL_DEFAULTS_SEQUENCE_BOMB_POT = {
  sequence: [
    {
      kind: 'round',
      round: 'flop',
      cards: ''
    }
  ]
}

// defaults for drill form
export const DRILL_DEFAULTS_DATA = {
  [DrillKind.Sequence]: {}
}
export const DRILL_DEFAULTS__NLH = {
  name: '',
  description: '',
  stopAt: StopAt.Hand,

  flavors: [],
  kind: DrillKind.Sequence,
  data: {},
  handsToPlay: 100,

  gaming_configuration: structuredClone(gameFormatList[0].value),
  max_players: 8,
  starting_stack: 20000,

  rebuy_configuration: {
    rebuy_trigger: 0,
    rebuy_amount: 10000,
    buyout_trigger: 100000,
    buyout_amount: 100
  }
}
export const DRILL_DEFAULTS__BOMB_POT = {
  name: '',
  description: '',
  stopAt: StopAt.Hand,

  flavors: [GameFlavor.BombPot],
  kind: DrillKind.Sequence,
  data: {},
  handsToPlay: 100,

  gaming_configuration: structuredClone(gameFormatList[0].value),
  max_players: 8,
  starting_stack: 20000,

  rebuy_configuration: {
    rebuy_trigger: 0,
    rebuy_amount: 10000,
    buyout_trigger: 100000,
    buyout_amount: 100
  }
}
